const trans = {
  Purchase: "المشتريات",
  "Purchase Orders": "المشتريات",
  "Delivery Date": "تاريخ التوصيل",
  "Search for a purchase order": "إبحث عن مشترى",
  "New Purchase Order": "طلب شراء جديد",
  "Send Email": "إرسال بريد إلكتروني",
  "Service Cost": "تكلفة الخدمة",
  "Select a supplier": "اختر موردًا",
  "Vendor Code": "رمز المورد",
  Production: "الإنتاج",
  SKU: "وحدة حفظ المخزون",
  "Cost per unit": "التكلفة لكل وحدة",
  "Total Cost": "التكلفة الإجمالية",
  "Central Storage Unit": "وحدة التخزين المركزية",
  "Inventory overview": "نظرة عامة على المخزون",
  "Inventory levels for every stocked product across your permitted branches.":
    "مستويات المخزون لكل منتج مخزن عبر الفروع المسموح لك بها.",
  "By product": "حسب المنتج",
  "By branch": "حسب الفرع",
  "Inventory by product": "المخزون حسب المنتج",
  "Inventory by branch": "المخزون حسب الفرع",
  "Inventory value": "قيمة المخزون",
  "Total Inventory": "إجمالي المخزون",
  "Showing {{count}} inventory rows": "عرض {{count}} صفًا من المخزون",
  "Search products": "البحث في المنتجات",
  "Export all branches": "تصدير جميع الفروع",
  "No branches to export": "لا توجد فروع للتصدير",
  "All stock levels": "جميع مستويات المخزون",
  "At risk": "معرض للخطر",
  "Healthy stock": "مخزون جيد",
  "Products at risk": "منتجات معرضة للخطر",
  "At or near the minimum holding inventory":
    "عند أو بالقرب من الحد الأدنى للمخزون",
  "Needs attention": "يحتاج إلى انتباه",
  Healthy: "جيد",
  "No product found for this barcode":
    "لم يتم العثور على منتج بهذا الباركود",
  "Inventory updated successfully": "تم تحديث المخزون بنجاح",
  Composite: "مركب",
  "Show composite products": "عرض المنتجات المركبة",
  "Inventory is calculated from component products":
    "يتم احتساب المخزون من المنتجات المكونة",
  "Order details": "تفاصيل الطلب",
  Approve: "موافقة",
  Reject: "رفض",
  "Supplier Code": "رمز المورد",
  "Product's SKU": "رمز المنتج (SKU)",
  "Product's Name": "اسم المنتج",
  Rejected: "مرفوض",
  Approved: "موافق عليه",
  Receive: "استلام",
  "Received Date": "تاريخ الاستلام",
  "Cancelled Date": "تاريخ الإلغاء",
  Id: "رمز التتبع",

  "Stock Transfer": "تحويل المخزون",
  "Search for a stock transfer": "ابحث عن تحويل المخزون",
  "Source Branch": "فرع المصدر",
  "Destination Branch": "فرع الوجهة",
  "New Transfer": "تحويل جديد",
  "Sent Date": "تاريخ الإرسال",
  "Duplicate Transfer": "تكرار التحويل",
  "Send Transfer": "إرسال التحويل",
  "Receive Transfer": "استلام التحويل",
  by: "بواسطة",
  By: "بواسطة",
  "Statement of Account for": "كشف حساب لـ",
  Cheque: "شيك",
  "Production Orders": "طلبات الإنتاج",
  "New Production Order": "طلب إنتاج جديد",
  "Completed Date": "تاريخ الإكمال",
  "Cancel Updates": "إلغاء التحديثات",
  "Duplicate Production": "تكرار الإنتاج",
  "Stock Update": "تعديل المخزون",
  "New Stock Update": "تعديل مخزون جديد",
  Waste: "هدر",
  "Stock Count": "جرد المخزون",
  waste: "هدر",
  count: "جرد المخزون",
  "Add All Products": "إضافة جميع المنتجات",
  "Select a product or scan barcode": "اختر منتجًا أو امسح الباركود",
  "Save & update inventory": "حفظ وتحديث المخزون",
  "Quantity Before Waste": "الكمية قبل الهدر",
  "Wasted Quantity": "الكمية المهدره",
  "Counted Quantity": "الكمية المعدودة",
  "Expected Quantity": "الكمية المتوقعة",
  "Are you sure you want to cancel?": "هل أنت متأكد أنك تريد الإلغاء؟",

  Registers: "صناديق الكاشير",
  "New Register": "صندوق جديد",
  Closed: "مغلق",
  "Register Closed": "الصندوق مغلق",
  "Opening Float": "الرصيد الافتتاحي",
  "Opening float": "الرصيد الافتتاحي",

  "Notes (optional)": "ملاحظات (اختياري)",
  "Open Register": "فتح الصندوق",
  "Switch Register": "تغير الصندوق",
  "Cash Movements": "حركات النقد",
  "Add Cash": "إضافة نقد",
  "Remove Cash": "إزالة نقد",
  Counted: "المعدود",
  "Enter Amount": "أدخل المبلغ",
  "Close Register": "إغلاق الصندوق",
  "Payments Summary": "ملخص المبيعات",

  "Are you sure you want to delete this register?":
    "هل أنت متأكد أنك تريد حذف هذا الصندوق؟",
  Note: "ملاحظة",
  "Cash out": "سحب نقدي",
  "Cash in": "إيداع نقدي",
  "Register Closures": "إغلاقات الصندوق",
  "Closing report by registers": "التقرير الختامي حسب الصندوقات",
  "Opening Date": "تاريخ الافتتاح",
  "Closed Date": "تاريخ الإغلاق",
  "Opening Amount": "المبلغ الافتتاحي",
  "Closing Amount": "المبلغ الختامي",
  "Opening Note": "ملاحظة الافتتاح",
  "Closing Note": "ملاحظة الإغلاق",
  "Expected Amount": "المبلغ المتوقع",
  "Select Register": "اختر الصندوق",

  "Inventory Movements Log": "سجل حركات المخزون",
  "A report that shows inventory movements details per product":
    "تقرير يعرض تفاصيل حركات المخزون لكل منتج",
  "A report that shows historical cost changes by product":
    "تقرير يعرض تغييرات التكلفة التاريخية لكل منتج",
  "Inventory Balance": "رصيد المخزون",
  "A report that shows the beginning and ending inventory levels for each product over a selected period":
    "تقرير يعرض رصيد المخزون لكل منتج في بداية ونهاية فترة محددة",

  Wastage: "الهدر",
  "A report that details inventory wastage": "تقرير يوضح هدر المخزون",

  "Receiving this purchase order will update the stock and the cost":
    "استلام أمر الشراء هذا سيؤدي إلى تحديث المخزون والتكلفة",
  "Are you sure you want to update the inventory?":
    "هل أنت متأكد أنك تريد تحديث المخزون؟",
  "This setting is intended for stores that handle their own deliveries. Enabling it will display delivery orders in the Smooth dashboard as 'WAREHOUSE PICKUP'. In this case, your driver is responsible for collecting the order from the Smooth warehouse before completing the delivery.":
    'هذا الإعداد مخصص للمتاجر التي تتولى عمليات التوصيل بنفسها. بتفعيله، ستظهر طلبات التوصيل في لوحة تحكم Smooth تحت مسمى "استلام من المستودع". في هذه الحالة، يكون سائق التوصيل مسؤولاً عن استلام الطلب من مستودع Smooth قبل إتمام عملية التوصيل.',
  "Enable custom delivery": "تفعيل خدمة التوصيل المخصصة",
  cash: "كاش",
  online: "اونلاين",
  wallet: "المحفظة",
  "loyalty points": "نقاط الولاء",
  "you need to add": "تحتاج إلى إضافة",
  "you need to remove": "تحتاج إلى إزالة",
  "When enabled, the delivery time will be calculated using the end time of the selected delivery slot. When disabled, the start time of the delivery slot will be used.":"عند التفعيل، سيتم احتساب وقت التوصيل باستخدام وقت انتهاء فترة التوصيل المحددة. وعند التعطيل، سيتم استخدام وقت بدء فترة التوصيل.",
  "Inventory Movements": "تتبع المخزون",
  "purchase": "شراء",
  "reverse-purchase": "ارجاع المشتريات",
  "transfer send": "إرسال تحويل",
  "transfer receive": "استلام تحويل",
  "reverse - transfer send": "ارجاع - إرسال التحويل",
  "reverse - transfer receive": "ارجاع - استلام التحويل",
  "production addition": "إضافة إنتاج",
  "production consumption": "استهلاك الإنتاج",
  "reverse  - production addition": "ارجاع - إضافة الإنتاج",
  "reverse - production consumption": "ارجاع - استهلاك الإنتاج",
  "order": "طلب",
  "cancel - order": "إلغاء الطلب",
  "uncancel - order": "التراجع عن إلغاء الطلب",
  "automatic return - order": "إرجاع تلقائي - طلب",
  "manual": "يدوي",
  "stock update - waste": "تحديث المخزون - هدر",
  "stock update - count": "تحديث المخزون - جرد",
  "auto-replenish": "تجديد تلقائي",
  "auto-reset": "إعادة ضبط تلقائي",
  "Add / Edit": "إضافة / تعديل",
  "Duplicate Stock Update": "تكرار تحديث المخزون",
  "Import Via Excel": "استيراد عبر إكسل",
  "Import Summary": "ملخص الاستيراد",
  "Total Products:": "إجمالي المنتجات:",
  "Valid Products:": "المنتجات الصالحة:",
  "Errors:": "الأخطاء:",
  "Invalid quantity (must be number)": "الكمية غير صالحة (يجب أن تكون رقمًا)",
  "Invalid cost (must be number)": "التكلفة غير صالحة (يجب أن تكون رقمًا)",
  "Invalid quantity (must be a non-negative number)":
    "الكمية غير صالحة (يجب أن تكون رقمًا غير سالب)",
  "Invalid cost (must be a non-negative number)":
    "التكلفة غير صالحة (يجب أن تكون رقمًا غير سالب)",
  "Product is not available in source branch":
    "المنتج غير متوفر في فرع المصدر",
  "Errors found in file": "تم العثور على أخطاء في الملف",
  "Product Not found": "المنتج غير موجود",
  "Duplicate product in file": "المنتج مكرر في الملف",
  "Unit Not found": "الوحدة غير موجودة",

  "Missing Id": "Id لا يوجد",
  "Missing sku": "SKU لا يوجد",
  "Missing barcode": "الباركود لا يوجد",

  "Additional Barcodes": "الباركودات الإضافية",
  "Scan or enter barcode": "امسح أو أدخل الباركود",
  Reason: "السبب",
  Expired: "منتهي الصلاحية",
  Damaged: "تالف",
  "Production Error": "خطأ في الإنتاج",
  "Customer Return": "مرتجع من العميل",
  Theft: "سرقة",
  "Use Order Creation Date for International Orders": "استخدام تاريخ إنشاء الطلب للطلبات الدولية",
  "Disable Pickup Orders on Smooth": "تعطيل طلبات الاستلام على Smooth",
  "Use Delivery Slot End Time": "استخدام وقت انتهاء فترة التوصيل",
  "When enabled, international orders will be dispatched to Smooth using the order's creation date and time as the delivery time, instead of the selected delivery slot.": "عند التفعيل، سيتم إرسال الطلبات الدولية إلى Smooth باستخدام تاريخ ووقت إنشاء الطلب كوقت للتوصيل، بدلاً من فترة التوصيل المحددة.",
  "When enabled, pickup orders will not be created on Smooth system.": "عند التفعيل، لن يتم إنشاء طلبات الاستلام على نظام Smooth.",
  "When enabled, the delivery time will be calculated using the end time of the selected delivery slot. When disabled, the start time of the delivery slot will be used.":"عند التفعيل، سيتم احتساب وقت التوصيل باستخدام وقت انتهاء فترة التوصيل المحددة. وعند التعطيل، سيتم استخدام وقت بدء فترة التوصيل."

};

export default trans;
